import Messages from '../components/Messages.vue'
import { snakeCaseToTitleCase } from '../util'

export default {
    data() {
        return {
            messages: [],
        }
    },
    components: {
        Messages,
    },
    methods: {
        addMessage(variant, text, timeoutMs = 5000) {
            let msgObj = { variant, text }
            this.messages.push(msgObj)

            if ('object' === typeof this.$analytics) {
                this.$analytics.track('message', { variant, text })
            }

            setTimeout(() => {
                let msgIndex = this.messages.indexOf(msgObj)
                this.messages.splice(msgIndex, 1)
            }, timeoutMs)
        },
        getResponseMessageFromAxiosException(exception, codeMessages = {}) {
            const statusCode = exception?.response?.status
            const data = exception?.response?.data

            if (!data) {
                return String(exception)
            }

            if (Object.keys(codeMessages).length > 0 && codeMessages[statusCode]) {
                return codeMessages[statusCode]
            } else if (Object.keys(data).length > 0 && statusCode > 399 && statusCode < 500) {
                let errString = ''

                if (data['non_field_errors']) {
                    errString += data['non_field_errors'].join('. ')
                }

                for (let key in data) {
                    if (key === 'non_field_errors') continue
                    errString += `${errString ? ' ' : ''}${snakeCaseToTitleCase(key)}: ${data[key]}`
                }

                return errString
            } else if (exception.message) {
                return exception.message
            }

            return String(exception)
        },
        extractResponseMessageFromAxiosException(exception, codeMessages = {}) {
            this.addMessage('danger', this.getResponseMessageFromAxiosException(exception, codeMessages))
            this.$emit('error', exception)
            return exception
        },
        axiosExtract(e, codeMessages = {}) {
            return this.extractResponseMessageFromAxiosException(e, codeMessages)
        },
    },
}
